import './SimpleMenu.scss';

const SimpleMenu = (props) =>
{
  const { title, menu, active } = props;

  return (
    <div className="d-none d-lg-block col">
      <div className="SimpleMenu">
        <h4 className="title">{title}</h4>
        <ul className="list-unstyled ps-0">
        {menu.map((item, index) => {
          return (
            <li key={index} className="mb-2">
              <svg width="1em" height="1em" viewBox="0 0 16 16" fill="#F2A900" xmlns="http://www.w3.org/2000/svg" className="me-2">
                <path fillRule="evenodd" clipRule="evenodd" d="M9.657 8L5.333 3.533l.839-.866L11.333 8l-5.161 5.333-.839-.866L9.657 8z"></path>
              </svg>
              <a href={item.link} className={`item ${active === index ?'active':''} btn p-0 btn btn-link`}>
                {item.text}
              </a>
            </li>
          );
        })}
        </ul>
      </div>
    </div>
  );
}

export default SimpleMenu;
